module.exports = __webpack_public_path__ + "static/media/orangeArrow.svg";